import { isError } from "./is-error.js";
import { isObject } from "./is-object.js";

export const stringifyArgs = ({ args }) =>
  args.map((arg) => {
    if (isObject(arg)) {
      if (isError(arg)) {
        return arg.stack;
      }

      return JSON.stringify(arg);
    }

    return arg;
  });
